import React from "react";
import SidebarNavGroup from "@/components/dashboard/SidebarNavGroup";

type SidebarNavGroupShape = {
  id: string;
  label: string;
  items: Array<{
    id: string;
    label: string;
    to: string;
  }>;
};

type SidebarNavProps = {
  homeTo: string;
  companyName: string;
  groups: SidebarNavGroupShape[];
};

export default function SidebarNav({
  homeTo: _homeTo,
  companyName,
  groups,
}: SidebarNavProps) {
  return (
    <div className="flex h-full flex-col">
      <div className="border-b border-slate-200 px-4 py-5 dark:border-slate-800 sm:px-6">
        <div className="rounded-2xl border border-slate-200 bg-slate-50 px-4 py-3 dark:border-slate-800 dark:bg-slate-900">
          <p className="text-[10px] font-black uppercase tracking-[0.35em] text-slate-400 dark:text-slate-500">
            Active Company
          </p>
          <p className="mt-2 text-sm font-bold text-slate-900 dark:text-slate-100">
            {companyName}
          </p>
        </div>
      </div>

      <div className="flex-1 overflow-y-auto">
        <nav
          aria-label="Company workspace navigation"
          className="space-y-4 px-4 py-5 sm:px-6"
        >
          {groups.length > 0 ? (
            groups.map((group) => (
              <SidebarNavGroup
                key={group.id}
                id={group.id}
                label={group.label}
                items={group.items}
              />
            ))
          ) : (
            <div className="rounded-2xl border border-dashed border-slate-200 bg-slate-50 px-4 py-5 dark:border-slate-800 dark:bg-slate-900">
              <p className="text-[10px] font-black uppercase tracking-[0.35em] text-slate-400 dark:text-slate-500">
                Dashboard
              </p>
              <p className="mt-3 text-sm leading-6 text-slate-600 dark:text-slate-300">
                Your tools will appear here when the owner assigns you credentials.
              </p>
            </div>
          )}
        </nav>
      </div>
    </div>
  );
}